/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pluginConfig: {},
  frontendConfig: {},
};

export const TenantSlicer = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setPluginConfig: (state, action) => {
      state.pluginConfig = action?.payload;
    },
    setFrontendConfig: (state, action) => {
      state.frontendConfig = action.payload;
    },
  },
});

export const { setPluginConfig, setFrontendConfig } = TenantSlicer.actions;

export default TenantSlicer.reducer;
